import { US_STATES, TAXES_PREP, TAXES_FILED } from './dropdown-options';

export const InputName = {
  EMAIL: 'user_email',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  US_PHONE_NUMBER: 'us_phone_number',
  DATE: 'date',
  DOB: 'dob',
  STATE: 'state',
  TAXES_FILED: 'taxes_filed',
  TAXES_PREP: 'taxes_prep',
  CHECKBOX_LEGAL1: 'optin_legal1',
  CHECKBOX_LEGAL2: 'optin_legal2',
  CHECKBOX_OPTIN1: 'optin_optin1',
  CHECKBOX_OPTIN2: 'optin_optin2',
} as const;

// eslint-disable-next-line -- intentionally naming the object the same as the type
export type InputName = typeof InputName[keyof typeof InputName];

export const InputType = {
  EMAIL: 'email',
  TEXT: 'text',
  PHONE: 'tel',
  SELECT: 'select',
  DATE: 'date',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
} as const;

// eslint-disable-next-line -- intentionally naming the object the same as the type
export type InputType = typeof InputType[keyof typeof InputType];

export const INPUT_MAP = {
  [InputName.EMAIL]: {
    type: InputType.EMAIL,
    rules: {
      pattern: {
        value: new RegExp(
          /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i
        ),
        message: 'Please enter a valid email.',
      },
    },
    maxLength: 320,
  },
  [InputName.FIRST_NAME]: {
    type: InputType.TEXT,
    maxLength: 320,
  },
  [InputName.LAST_NAME]: {
    type: InputType.TEXT,
    maxLength: 320,
  },
  [InputName.US_PHONE_NUMBER]: {
    type: InputType.PHONE,
    rules: { 
      pattern: {
        value: new RegExp(/^[1-9]\d{2}[2-9]\d{6}$/),
        message: 'Please enter a valid phone number.'
      } 
    },
  },
  [InputName.STATE]: {
    type: InputType.SELECT,
    options: US_STATES
  },
  [InputName.DATE]: {
    type: InputType.DATE,
    rules: { pattern: new RegExp(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/) },
  },
  [InputName.DOB]: {
    type: InputType.DATE,
    rules: { pattern: new RegExp(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/) },
    max: new Date().toISOString().split('T')[0] 
  },
  [InputName.TAXES_FILED]: {
    type: InputType.RADIO,
    options: TAXES_FILED
  },
  [InputName.TAXES_PREP]: {
    type: InputType.SELECT,
    options: TAXES_PREP
  },
  [InputName.CHECKBOX_LEGAL1]: {
    type: InputType.CHECKBOX,
  },
  [InputName.CHECKBOX_LEGAL2]: {
    type: InputType.CHECKBOX,
  },
  [InputName.CHECKBOX_OPTIN1]: {
    type: InputType.CHECKBOX,
  },
  [InputName.CHECKBOX_OPTIN2]: {
    type: InputType.CHECKBOX,
  },
} as const;
// eslint-disable-next-line -- intentionally naming the object the same as the type
export type INPUT_MAP = typeof INPUT_MAP[keyof typeof INPUT_MAP];